import { useEffect, useState } from "react";
// import { useNavigate } from 'react-router-dom';
import { fetchPatientStatusApiCall } from "./reportService";
import { errorToast } from "../../components/toastmessage/toastmessage";


const useReportTableHook = () => {
    const [patientStatusState, setPatientStatusState] = useState([]);

    useEffect(() => {
        const fetchPatient = async () => {
            try {
                let result = await fetchPatientStatusApiCall();
                if (result.status === 200) setPatientStatusState(result?.data?.result)
            } catch (e) {
                errorToast("Failed to fetch Rooms")
            }

        }
        fetchPatient();

    }, []);

   

    const handleGetRowId = (e) => {
        return e?.id
    }

   
    return {
        patientStatusState,
        handleGetRowId,
      
    }


};


export default useReportTableHook;
